import { Typography, TypographyProps } from '@mui/material';

/**
 * Shared section label used by both the account menu (e.g. "This app") and
 * `AppSwitcherPanel` (e.g. "Neon Apps", "Go to Dashboard"), so every panel section label
 * in the suite stays visually identical. No vertical padding is added — the row height is
 * the `overline2` variant's own ~30px line height, matching the Figma spec.
 */
export function SectionSubheader({ sx, ...rest }: TypographyProps) {
  return (
    <Typography
      variant="overline2"
      color="textSecondary"
      sx={[{ display: 'block', px: 2 }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...rest}
    />
  );
}
